//------------------------------------------------------------------------------
// BFA10103G 共架申込 機器設備
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {
  PositiveButton,
  StandardButton,
} from '@/components/atoms/Buttons/PositiveButton';

/**
 * 操作パネル
 */
function OperationPanel({
  orderNo,
  savable,
  navigate,
  onSave,
}) {

  // 通信設備ボタン
  const handleTusin = () => {
    console.info(`通信設備 order=${orderNo}`);
    if (orderNo.valid()) {
      navigate('/bfa10104g/' + orderNo.path());
    }
  }

  // 申込内容確認ボタン
  const handleConfirm = () => {
    console.info(`内容確認 order=${orderNo}`);
    if (orderNo.valid()) {
      navigate('/bfa10109g/' + orderNo.path());
    }
  }

  // 戻る - 共架申込基本情報画面へ
  const handleBack = () => {
    console.info(`戻る order=${orderNo}`);
    if (orderNo.valid()) {
      navigate('/bfa10102g/' + orderNo.path());
    }
  }

  //----------------------------------------------------------------------------
  // 描画
  //----------------------------------------------------------------------------
  // 画面遷移可否
  const navigatable = orderNo?.valid();

  // 操作パネル描画
  return (
    <Grid container spacing={1}
      sx={{
        mt: 1,
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      {/* 通信設備 */}
      <Grid item>
        <PositiveButton
          variant="contained"
          size="large"
          disabled={!navigatable}
          onClick={handleTusin}
        >
          <span>通信設備</span>
        </PositiveButton>
      </Grid>

      {/* 申込内容確認 */}
      <Grid item>
        <PositiveButton
          variant="contained"
          size="large"
          disabled={!navigatable}
          onClick={handleConfirm}
        >
          <span>申込内容確認</span>
        </PositiveButton>
      </Grid>

      {/* 一時保存 */}
      <Grid item>
        <PositiveButton
          variant="contained"
          startIcon={<SaveAltIcon />}
          size="large"
          disabled={!savable}
          onClick={onSave}
        >
          <span>一時保存</span>
        </PositiveButton>
      </Grid>

      {/* 戻る */}
      <Grid item>
        <StandardButton
          variant="contained"
          size="large"
          startIcon={<KeyboardReturnIcon />}
          onClick={handleBack}
        >
          <span>基本情報に戻る</span>
        </StandardButton>
      </Grid>
    </Grid>
  );
}

// プロパティ
OperationPanel.propTypes = {
  orderNo: PropTypes.object,  // 申込番号
  savable: PropTypes.bool,    // 保存可能

  // ルーティング
  navigate: PropTypes.func,

  // イベントハンドラー
  onSave: PropTypes.func.isRequired,    // 一時保存
};

// エクスポート
export default OperationPanel;
